import { Transform } from 'class-transformer';
import { IsNumber, isNumberString } from 'class-validator';
import { a as applyDecorators } from './applyDecorators_chunkExport-D6nMF0T1.mjs';

function convertToNumber(value) {
    if (isNumberString(value)) return parseFloat(value);
    return value;
}
function IsNumberFromString(numberOptions, options) {
    return applyDecorators(Transform((params)=>convertToNumber(params.value), {
        toClassOnly: true
    }), IsNumber(numberOptions, options));
}

export { IsNumberFromString as I };
//# sourceMappingURL=isNumberFromString_chunkExport-CWsTlw1s.mjs.map
